import React, { useEffect, useState, useRef, useMemo } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { NavLink, Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { Box, Pagination } from "@mui/material";
import { Loading1 } from "../../components/Loadings/index";
import Loading from "../../components/Loading";
import clsx from "clsx";
import useLazyLoad from "../../Helpers/useLazyLoading";
import { connect } from "react-redux";
import {
  getPropertyDetail,
  unlikeProperty,
  likeProperty,
  getPropertyList,
  hiddenProperty,
} from "../../actions/propertyAction";
import { loadUser } from "../../actions/authActions";
import { toast } from "react-toastify";
import { LoadingContent } from "../../Helpers/LoadingPosts";
// react virtual
// import imgg from "assets/Image_not_available.png"
let rowsPerPage = 12;
const BrokenImage = "assets/no-picture-available-icon-1.jpg";

const theme = createTheme({
  palette: {
    primary: {
      main: "#f5d792",
      darker: "#053e85",
    },
    neutral: {
      main: "#64748B",
      contrastText: "#fff",
    },
  },
});

const CardContent = ({
  allData,
  properties1,
  getPropertyList,
  getPropertyDetail,
  auth,
  likeProperty,
  unlikeProperty,
  hiddenProperty,
  changePage,
  page,
  filterLoading,
  room,
  search,
  filterText,
  rentalPeriod,
  propertyType,
  propSizeValMin,
  propSizeValMax,
  propPriceValMin,
  propPriceValMax,
  // newToday ? "1" : newThisWeek ? "2" : ""={}
  newToday,
  newThisWeek,
  navType,
  propertyLoad,
  propertyTotal,
  propertyData,
  setPage,
  properties,
  setAllProperty,
  label,
  gender,
  pets,
  inhabitants,
  smoking,
}) => {
  const triggerRef = useRef(null);
  const { frontLabelsName } = label;
  const isAuth = auth.isAuthenticated;
  const userName = auth.user;
  const [hasMore, setHasMore] = useState(true);
  const getMoreData = () => {
    if (propertyData?.property?.hasNextPage) {
      setPage((prev) => prev + 1);
      setHasMore(true);
    } else {
      setHasMore(false);
    }
    // setPage((prev)=>prev + 1)
  };

  const handleChange = (e, p) => {
    changePage(p);
  };

  const getPropertyType = (val) => {
    if (val?.length > 0) {
      let label;
      if (val?.includes("1") && val?.includes("2") && val?.includes("3")) {
        label = "Rental, Sale, PG";
      } else if (val?.includes("1") && val?.includes("2")) {
        label = "Rental, Sale";
      } else if (val?.includes("2") && val?.includes("3")) {
        label = "Sale, PG";
      } else if (val?.includes("3") && val?.includes("1")) {
        label = "Rental, PG";
      } else if (val?.includes("1")) {
        label = "Rental";
      } else if (val?.includes("2")) {
        label = "Sale";
      } else {
        label = "PG";
      }
      return label;
    }
  };



  const getTypeName = (val) => {
    if (val === "detachedHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_detached_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
              "value"
            ] || "lbl_detached_house"
          : "lbl_detached_house"
        : "lbl_detached_house";
    } else if (val === "duplex") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0]["value"] ||
            "lbl_duplex"
          : "lbl_duplex"
        : "lbl_duplex";
    } else if (val === "tripleAptHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")[0][
              "value"
            ] || "lbl_triple_apt_house"
          : "lbl_triple_apt_house"
        : "lbl_triple_apt_house";
    } else if (val === "aptBulding") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0]["value"] ||
            "lbl_apt_building"
          : "lbl_apt_building"
        : "lbl_apt_building";
    } else if (val === "townhouseTwin") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
              "value"
            ] || "lbl_townhouse_twin"
          : "lbl_townhouse_twin"
        : "lbl_townhouse_twin";
    } else if (val === "garage") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
            "lbl_garage"
          : "lbl_garage"
        : "lbl_garage";
    } else if (val === "summerHouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0]["value"] ||
            "lbl_summer_house"
          : "lbl_summer_house"
        : "lbl_summer_house";
    } else if (val === "cotenant") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0]["value"] ||
            "lbl_co_tenant"
          : "lbl_co_tenant"
        : "lbl_co_tenant";
    } else if (val === "hotelGesthouse") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")[0][
              "value"
            ] || "lbl_hotel_guest_house"
          : "lbl_hotel_guest_house"
        : "lbl_hotel_guest_house";
    }
  };

  // like or unlike code start here

  const like = async (e, property_id) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      let a = [...properties1];
      let b = a.filter((e) => e._id === property_id)[0];
      b.favourite = 1;
      let index = a.findIndex((object) => {
        return object._id === property_id;
      });
      a[index] = b;

      setAllProperty(a);
      let newAddLike = {
        property_id: property_id,
      };
      const res = await likeProperty(newAddLike).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.data.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.data.message)[0][
                  "value"
                ] || ress.data.message
              : ress.data.message
            : ress.data.message
        );
        getPropertyList(
          1,
          page * rowsPerPage,
          search,
          JSON.stringify(room),
          filterText,
          rentalPeriod,
          propertyType,
          propSizeValMin,
          propSizeValMax,
          propPriceValMin,
          propPriceValMax,
          newToday ? "1" : newThisWeek ? "2" : "",
          "",
          navType,
          gender,
          pets,
          inhabitants,
          smoking
        ).then((res) => {
          setAllProperty(res?.docs);
        });
      });
    } else {
      toast.error("Please login to access this button");
    }
  };

  // end here like and unlike

  // unlike funtion start here

  const unlike = async (e, property_id) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      let a = [...properties1];
      let b = a.filter((e) => e._id === property_id)[0];
      b.favourite = 0;
      let index = a.findIndex((object) => {
        return object._id === property_id;
      });
      a[index] = b;

      setAllProperty(a);
      const res = await unlikeProperty(property_id).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.message)[0]["value"] ||
                ress.message
              : ress.message
            : ress.message
        );
        getPropertyList(
          1,
          page * rowsPerPage,
          search,
          JSON.stringify(room),
          filterText,
          rentalPeriod,
          propertyType,
          propSizeValMin,
          propSizeValMax,
          propPriceValMin,
          propPriceValMax,
          newToday ? "1" : newThisWeek ? "2" : "",
          "",
          navType,
          gender,
          pets,
          inhabitants,
          smoking
        ).then((res) => {
          setAllProperty(res?.docs);
        });
      });
    } else {
      toast.error("Please login to access this button");
    }
  };

  // end here unlike

  // hidden property start here

  const hidden = async (e, property_id) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      let newhidden = {
        property_id: property_id,
      };
      const res = hiddenProperty(newhidden).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.data.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.data.message)[0][
                  "value"
                ] || ress.data.message
              : ress.data.message
            : ress.data.message
        );
        getPropertyList(
          1,
          page * rowsPerPage,
          search,
          JSON.stringify(room),
          filterText,
          rentalPeriod,
          propertyType,
          propSizeValMin,
          propSizeValMax,
          propPriceValMin,
          propPriceValMax,
          newToday ? "1" : newThisWeek ? "2" : "",
          "",
          navType,
          gender,
          pets,
          inhabitants,
          smoking
        ).then((res) => {
          setAllProperty(res?.docs);
        });
      });
    } else {
      toast.error("Please login to access this button");
    }
  };

  const imageOnError = (event) => {
    event.currentTarget.src = BrokenImage;
  };

  return (
    <>
      {/* <div  style={{scrollBehavior:'smooth',overflow:"hidden",}}> */}
      <InfiniteScroll
        dataLength={properties1.length}
        next={getMoreData}
        hasMore={propertyData?.property?.hasNextPage}
        style={{ overflowX: "hidden" }}
        scrollableTarget={0.9}
        loader={
          <p style={{ textAlign: "center", marginTop: 20 }}>
            <b>
              {frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_loading").length > 0
                  ? frontLabelsName.filter((e) => e.key == "lbl_loading")[0][
                      "value"
                    ] || "lbl_loading"
                  : "lbl_loading"
                : "lbl_loading"}
              ...
            </b>
          </p>
        }
        endMessage={
          <p style={{ textAlign: "center", marginTop: 20 }}>
            {!propertyLoad && properties1.length !== 0 && (
              <b>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_no_more_property")
                      .length > 0
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_no_more_property"
                      )[0]["value"] || "lbl_no_more_property"
                    : "lbl_no_more_property"
                  : "lbl_no_more_property"}
              </b>
            )}
          </p>
        }
      >
        {/* {!propertyLoading && !filterLoading && ( */}
        <div className={`row d-flex ${allData ? "row_content_data" : "row"} `}>
          {
            // !propertyLoad &&
            properties1.length > 0 &&
              properties1.map((obj, indx) => (
                <div className="col-lg-4 col-md-6" key={indx}>
                  <div className="view-card-main mt-4">
                    <div className="icon-main-view">
                      {obj?.favourite === 0 ? (
                        <img
                          src="assets/icons/Favourite.svg"
                          alt="hshshs"
                          onClick={(e) => like(e, obj?._id)}
                          style={{
                            cursor: "pointer",
                            width: "32px",
                            height: "32px",
                          }}
                        />
                      ) : (
                        <img
                          src="assets/like.svg"
                          alt="hshshs"
                          onClick={(e) => unlike(e, obj?._id)}
                          style={{
                            cursor: "pointer",
                            width: "32px",
                            height: "32px",
                          }}
                        />
                      )}

                      <img
                        src="assets/hidden.svg"
                        alt="hshshs"
                        style={{
                          cursor: "pointer",
                          width: "32px",
                          height: "32px",
                        }}
                        onClick={(e) => hidden(e, obj?._id)}
                      />
                    </div>
                    <NavLink to={`/property-details/${obj._id}`}>
                      <div
                        className={`${
                          allData ? "img-view-main3" : "img-view-main"
                        }`}
                      >
                        <img
                          src={
                            obj.cover_photo
                              ? obj.cover_photo
                              : obj.photo_gallery[0]
                          }
                          alt="cover_photo"
                          onError={imageOnError}
                          fetchpriority="high"
                        />
                      </div>
                      <div className="overlayblack-card">
                        <div className="set-overlay px-2" style={{lineHeight:1.2}}>
                       
                          {/* <p>{`${
                          obj.location.length > 45
                            ? obj.location.substring(0, 45) + " ..."
                            : obj.location
                        } `}</p> */}
                        <p className="location-style" style={{fontWeight:'bolder'}}>{obj.location}</p>
                          <p className="area-style">{obj.area} </p> 
                          <div className="bottom-desc d-flex">
                            <p>
                              {`${getTypeName(obj?.propertyType)}, ${
                                obj.bhk === "Storage"
                                  ? frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_storage"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_storage"
                                        )[0]["value"] || "lbl_storage"
                                      : "lbl_storage"
                                    : "lbl_storage"
                                  : obj.bhk === "Single Room"
                                  ? frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_single_room"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_single_room"
                                        )[0]["value"] || "lbl_single_room"
                                      : "lbl_single_room"
                                    : "lbl_single_room"
                                  : obj.bhk === "Studio"
                                  ? frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_studio"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_studio"
                                        )[0]["value"] || "lbl_studio"
                                      : "lbl_studio"
                                    : "lbl_studio"
                                  : `${obj?.bhk} ${
                                      frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_rooms"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_rooms"
                                            )[0]["value"] || "lbl_rooms"
                                          : "lbl_rooms"
                                        : "lbl_rooms"
                                    }`
                              }, ${obj.size} ㎡` }
                            </p>
                            <p>
                              {obj.propertyPrice ||
                                obj.property_price ||
                                obj.sale_price ||
                                obj.pg_price}{" "}
                              kr.
                            </p>
                          </div>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                </div>
              ))
          }

          {!propertyLoad && properties1.length === 0 && (
            <div className="text-center">
              <p>
                {frontLabelsName
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_no_property_found_criteria"
                    ).length > 0
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_no_property_found_criteria"
                      )[0]["value"] || "lbl_no_property_found_criteria"
                    : "lbl_no_property_found_criteria"
                  : "lbl_no_property_found_criteria"}
              </p>
            </div>
          )}
          {/* {!propertyLoad && properties.length === propertyTotal && (
            <div className="text-center mt-5">
              <p>No more properties available</p>
            </div>
          )} */}

          {/* <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={4}
          >
            <ThemeProvider theme={theme}>
              {property.docs.length > 0 && !propertyLoading && (
                <Pagination
                  count={property.totalPages}
                  color="primary"
                  page={page}
                  onChange={handleChange}
                  shape="rounded"
                  sx={{ textAlign: "center" }}
                />
              )}
            </ThemeProvider>
          </Box> */}
        </div>
        {/* )} */}

        {/* <div ref={triggerRef} className={clsx('trigger',{visible:false})}>
                <LoadingContent/>
      </div> */}

        {propertyLoad && properties1.length === 0 && <Loading1 />}
        {propertyLoad &&
          properties1.length > 0 &&
          propertyData.property.hasNextPage && <Loading1 height={100} />}

        {/* {propertyData.property.hasNextPage === false && (
        <div className="text-center mt-5">
          <p>No more property available</p>
        </div>
      )} */}
      </InfiniteScroll>
      {/* </div> */}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  getPropertyDetail,
  getPropertyList,
  likeProperty,
  unlikeProperty,
  hiddenProperty,
  loadUser,
})(CardContent);
